import { Effect } from 'effect';
import { designTokensCss, googleFontsHref } from '@okrapdf/design-system';
import { brandCopyEffect, getBrandEffect } from './brand';
import type { BrandConfig } from './brand/types';

const TOKEN_STYLE_ID = 'okra-design-system-tokens';
const FONT_LINK_ID = 'okra-design-system-fonts';

const applyBrandDocumentChromeEffect = Effect.fn('web.designSystem.applyChrome')(function* (
  brand: BrandConfig,
) {
  document.documentElement.dataset.brand = brand.id;
  if (brand.id === 'okrapdf') return;

  document.title = yield* brandCopyEffect(document.title, brand);
  for (const link of document.querySelectorAll<HTMLLinkElement>(
    'link[rel="icon"], link[rel="apple-touch-icon"]',
  )) {
    link.href = link.rel === 'apple-touch-icon' ? brand.assets.appleTouchIcon : brand.assets.favicon;
  }
  const siteName = document.querySelector<HTMLMetaElement>('meta[property="og:site_name"]');
  if (siteName) siteName.content = brand.seo.siteName;
});

export const ensureDesignSystemTokensEffect = Effect.fn('web.designSystem.ensureTokens')(function* () {
  if (typeof document === 'undefined') return;

  const brand = yield* getBrandEffect();
  yield* applyBrandDocumentChromeEffect(brand);

  const href = googleFontsHref();
  if (href && !document.getElementById(FONT_LINK_ID)) {
    const fontLink = document.createElement('link');
    fontLink.id = FONT_LINK_ID;
    fontLink.rel = 'stylesheet';
    fontLink.href = href;
    document.head.appendChild(fontLink);
  }

  const css = designTokensCss(brand.theme);
  const existing = document.getElementById(TOKEN_STYLE_ID);
  if (existing instanceof HTMLStyleElement) {
    if (existing.textContent !== css) existing.textContent = css;
    return;
  }

  const style = document.createElement('style');
  style.id = TOKEN_STYLE_ID;
  style.textContent = css;
  document.head.appendChild(style);
});

export function ensureDesignSystemTokens(): void {
  Effect.runSync(ensureDesignSystemTokensEffect());
}
